var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lists-no"},_vm._l((_vm.languages),function(lang,langIndex){return _c('span',{key:langIndex,staticClass:"flags"},[_c('vue-country-flag',{attrs:{"country":_vm.getLanguageFromLabel(lang),"size":_vm.size}}),(_vm.align)?_c('span',[_c('br')]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }